import React, { useState } from "react";
import Select from "react-select";
import { selectSetupStyle } from "../PaletteDropdown/index";

const EmailNotification = (props) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const options = [
    {
      value: true,
      text: "on",
    },
    {
      value: false,
      text: "off",
    },
  ];

  const handleChange = (e) => {
    setSelectedOption(e);
    props.onChange(e.value);
  };

  return (
    <div className="form-line-input-wrapper">
      <label className="form-label user-settings-form-label">
        {props.label}
      </label>
      <div>
        <Select
          isSearchable={false}
          value={options.find(
            (o) => o.value === (selectedOption?.value ?? props.value)
          )}
          options={options}
          onChange={handleChange}
          styles={selectSetupStyle}
          getOptionLabel={(e) => (
            <div>
              <div>{e.icon}</div>
              <div style={{ cursor: "pointer" }}>{e.text}</div>
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default EmailNotification;
